import React from "react";



const Testimonials = () => {
  return (
    <>
    <h2 class="nsTitle">TESTIMONIALS</h2>
    <div className="nsItem">
            
            <h2 className="nsTitleSm">Ever since I started using ireporter there has been development in our county.leaders are now doing their work to maintain a reputation </h2>
        </div>
     </> 
  );
};

export default Testimonials;